/**
 * נתוני דמה לבדיקת UI בלבד — לא בשימוש בפרודקשן.
 * מופעל רק מנתיב ‎/debug/flight-proposal/… עם ‎?mock=1 (ברירת מחדל).
 */

export function getFlightProposalDebugMockProposal(dynamicPackageId) {
  const id = dynamicPackageId || "debug";

  return {
    proposal_sent: true,
    total_price: 4820,
    currency: "ILS",
    ldsorderid: "MOCK-LDS-1001",
    hr_flight_module: {
      lds_reservation_status: "proposal_pushed_to_lds",
    },
    offer: {
      dep_date: "20260615",
      ret_date: "20260622",
      our_price: 4100,
      linked_flights: {
        flight: [
          {
            leg: {
              airlineCode: "LY",
              departure: { city: "תל אביב", airport: "TLV", time: "06:15" },
              arrival: { city: "אתונה", airport: "ATH", time: "10:40" },
              flightNum: "LY001",
            },
          },
          {
            leg: {
              airlineCode: "LY",
              departure: { city: "אתונה", airport: "ATH", time: "18:20" },
              arrival: { city: "תל אביב", airport: "TLV", time: "22:05" },
              flightNum: "LY002",
            },
          },
        ],
      },
      passengers_info: [
        {
          adults: [{ firstName: "ישראל", lastName: "ישראלי" }],
          kids: [{ firstName: "נועה", lastName: "ישראלי" }],
          infants: [],
        },
      ],
      supplement: {
        bag1: {
          checked: true,
          orig: {
            supp: {
              type: "BAG",
              fare: 220,
              description: 'מזוודה נוספת 23 ק"ג',
              paxRef: "1",
            },
          },
        },
        tr1: {
          checked: true,
          orig: {
            supp: {
              type: "TROLLEY",
              fare: 60,
              paxRef: "1",
            },
          },
        },
      },
    },
    id,
  };
}
